// Function to dynamically create the query string based on passed parameters and handle arrays
export const createQueryString = (params: Partial<any>): string => {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .flatMap(([key, value]) =>
      Array.isArray(value)
        ? value.map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`) // Repeat for arrays
        : `${encodeURIComponent(key)}=${encodeURIComponent(value!)}`,
    )
    .join('&');
};
